

























































































































































































































// vue
import {
    computed,
    defineComponent,
    onBeforeMount,
    ref,
} from '@vue/composition-api';

// store
import store from '@/store';
import { useStore } from '@/store';

// hooks
import { useGeoRecordDelete } from '@/vue3/hooks/geoRecordDeleteHook';
import { useNotify } from '../hooks/notifyHook';
import { useGeoRecord } from '../hooks/geoRecordHook';
import { Role } from '../api/models';

// services
import { useService } from '@/vue3/api/services';

import {
    Category,
    FileUpload,
    Measurement,
    Notes,
    Project,
    Task,
    Title,
    Model,
    Height,
    Label,
    Fill,
    MeasureLabel,
    Tags,
    Events,
    Visibility,
    Opacity,
} from '@/vue3/components/geo-record-editor';

// primevue
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import { Portal } from '@linusborg/vue-simple-portal';
import Confirm from '@/vue3/components/Confirm.vue';
import Dialog from 'primevue/dialog';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';

export default defineComponent({
    name: 'Editor',
    components: {
        Category,
        FileUpload,
        Measurement,
        Notes,
        Project,
        Task,
        Title,
        Model,
        Height,
        Label,
        Fill,
        Tags,
        Events,
        Button,
        MeasureLabel,
        Portal,
        Visibility,
        ProgressSpinner,
        Confirm,
        Dialog,
        Accordion,
        AccordionTab,
        Opacity,
    },
    props: {
        mapbox: {
            type: Object,
            default: () => {},
        },
        value: {
            type: Object,
            default: () => {},
        },
        saveGeoRecord: {
            type: Function,
            default: () => {},
        },
        declineArchiveMove: {
            type: Function,
            default: () => {},
        },
        cancelModify: {
            type: Function,
            default: () => {},
        },
        isCreating: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        categorySummaries: {
            type: Array,
            default: () => [],
        },
        clearGeoRecord: {
            type: Function,
            default: () => {},
        },
        updateGeoRecordExternal: {
            type: Function,
            default: () => {},
        },
        updateAndRefreshGeoRecord: {
            type: Function,
            default: () => {},
        },
        toggleModifyToolVisibility: {
            type: Function,
            default: () => {},
        },
        isModifyAllowed: {
            type: Boolean,
            default: true,
        },
        updateData: {
            type: Function,
            default: () => {},
        },
        isEditorVisible: {
            type: Boolean,
            default: false,
        },
        setIsEditorVisible: {
            type: Function,
            default: () => {},
        },
        refreshTable: {
            type: Function,
            default: () => {},
        },
        rowId: {
            type: Number,
            default: 0,
        },
        toggleIsArchive: {
            type: Function,
            default: () => {},
        },
        layerTree: {
            type: Object,
            default: null,
        },
        isArchiveRecord: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:activeIndex'],
    setup(props: any, { emit }) {
        // store
        const { getters } = useStore();

        // services
        const {
            updateGeoRecord,
            getRole,
            getGeoRecord,
            createArchiveGeoRecord,
        } = useService();

        // hooks
        const { deleteGeoRecordLayer } = useGeoRecordDelete();
        const { successToast } = useNotify();
        const {
            removeSelectedGeoRecord,
            removeGeoRecordExtrusion,
            removeGeoRecord,
        } = useGeoRecord();

        // refs
        const activeIndex = ref(0);
        const geoRecord = ref(props.value);
        const permissionsInitArr: Array<string> = [];
        const role = ref<Role>({
            permissions: [...permissionsInitArr],
        } as Role);

        const isArchiveWarningVisible = ref<boolean>(props.isArchiveRecord);

        const isDeleteVisible = ref<boolean>(false);
        const isDeleteLoading = ref<boolean>(false);
        const tabs = [
            { label: 'Title', component: Title },
            { label: 'Notes', component: Notes },
            { label: 'Category', component: Category },
            { label: 'Tags', component: Tags },
            { label: 'Events', component: Events },
            { label: 'Visibility', component: Visibility },
            { label: 'Project', component: Project },
            { label: 'Model', component: Model },
            { label: 'Task', component: Task },
            { label: 'Attachments', component: FileUpload },
            { label: 'Height', component: Height },
            { label: 'Label', component: Label },
            { label: 'Fill', component: Fill },
            { label: 'Opacity', component: Opacity },
            { label: 'Vertex Label', component: MeasureLabel },
        ];

        // computed
        const isNonGeometry = computed(() => {
            if (!props.value.geometry) {
                return false;
            }
            if (props.value.geometry.coordinates[0] === 0) {
                return true;
            }
            return false;
        });

        const selectedComponent = computed(() => {
            return filterTabs.value[activeIndex.value]?.component || null;
        });

        const filterTabs = computed(() => {
            let uniqueIdCounter = 0;

            return tabs
                .filter((tab) => {
                    if (
                        store.getters.account.id !== props.value.accountId &&
                        tab.label === 'Visibility'
                    ) {
                        return false;
                    }
                    return true;
                })
                .map((tab) => {
                    return {
                        ...tab,
                        id: uniqueIdCounter++,
                    };
                });
        });

        const isGeomPolygon = computed(() => {
            if (
                !props.isLoading &&
                props.value.geometry &&
                (props.value.geometry.type === 'Polygon' ||
                    props.value.geometry.type === 'MultiPolygon')
            ) {
                return true;
            } else {
                return false;
            }
        });

        const isFirstTabSelected = computed(() => activeIndex.value === 0);

        const isLastTabSelected = computed(
            () => activeIndex.value === filterTabs.value.length - 1,
        );

        const visibleTabs = computed(() => {
            if (isFirstTabSelected.value) {
                return filterTabs.value.slice(0, 2);
            } else if (isLastTabSelected.value) {
                return filterTabs.value.slice(-2);
            } else {
                return filterTabs.value.slice(
                    activeIndex.value - 1,
                    activeIndex.value + 2,
                );
            }
        });

        // methods
        const selectTab = (index: number) => {
            activeIndex.value = index;
            emit('update:activeIndex', index);
        };

        const scrollLeft = () => {
            if (activeIndex.value > 0) {
                activeIndex.value--;
            }
        };

        const scrollRight = () => {
            if (activeIndex.value < filterTabs.value.length - 1) {
                activeIndex.value++;
            }
        };

        const setRoleValue = async (): Promise<void> => {
            role.value = await getRole(getters.account.roleId);
        };

        const confirmDeleteGeoRecord = async () => {
            isDeleteLoading.value = true;
            try {
                await deleteGeoRecordLayer(props.mapbox.map, props.value);
                successToast(
                    `Geo Record: '${props.value.title}' deleted.`,
                    'fullscreen',
                );

                props.clearGeoRecord();
                await props.layerTree.refreshGeoRecordTreeAndState();
            } catch (error) {
                window.console.log(error);
                isDeleteLoading.value = false;
            }
            toggleIsDeleteVisible();
            isDeleteLoading.value = false;
        };

        const confirmDecline = () => {
            toggleIsDeleteVisible();
        };

        const confirmArchive = () => {
            props.saveGeoRecord();
            isArchiveWarningVisible.value = false;
        };

        const declineArchive = () => {
            props.declineArchiveMove();
            isArchiveWarningVisible.value = false;
        };

        const toggleIsDeleteVisible = () => {
            isDeleteVisible.value = !isDeleteVisible.value;
        };

        const convertToIsoString = (dateString) => {
            const [day, month, year] = dateString.split('/');
            const passDate = new Date(`${year}-${month}-${day}T00:00:00Z`);
            return passDate.toISOString();
        };

        const changeDateFormat = (geoRecord: any): void => {
            let element = {
                created: geoRecord.created,
                startDate: geoRecord.startDate,
                dueDate: geoRecord.dueDate,
                endDate: geoRecord.endDate,
            };

            geoRecord.created = convertToIsoString(element.created);
            geoRecord.startDate = convertToIsoString(element.startDate);
            geoRecord.dueDate = convertToIsoString(element.dueDate);
            geoRecord.endDate = convertToIsoString(element.endDate);
        };

        const moveGeoRecordToArchive = async (geoRecord: any) => {
            await createArchiveGeoRecord(geoRecord);

            successToast(
                `Geo Record: '${geoRecord.title}' successfully archived.`,
                'fullscreen',
            );

            removeSelectedGeoRecord(props.mapbox.map, geoRecord);
            removeGeoRecordExtrusion(props.mapbox.map, geoRecord);
            removeGeoRecord(props.mapbox.map, geoRecord);
        };

        const updateGeoRecordData = async (): Promise<void> => {
            changeDateFormat(props.value);

            if (props.value.archiveEventId) {
                await moveGeoRecordToArchive(geoRecord.value);
            } else {
                await updateGeoRecord(geoRecord.value, false);
            }
            props.refreshTable();
            props.setIsEditorVisible();
        };

        const setIsPrivate = (): void => {
            geoRecord.value = {
                ...geoRecord.value,
                isPrivate: !geoRecord.value.isPrivate,
            };
        };

        const handleGeoRecordPropertyUpdate = (
            geoRecordProperties: any = {},
        ): void => {
            geoRecord.value = { ...geoRecord.value, ...geoRecordProperties };
            props.updateGeoRecordExternal(geoRecord.value);
            return geoRecord.value;
        };

        // lycycle
        onBeforeMount(async () => {
            try {
                await setRoleValue();

                if (props.isEditorVisible) {
                    geoRecord.value = await getGeoRecord(props.rowId);
                }
            } catch (error) {
                console.error('Error fetching role:', error);
            }
        });

        return {
            store,
            isArchiveWarningVisible,
            confirmArchive,
            declineArchive,
            isDeleteVisible,
            isDeleteLoading,
            toggleIsDeleteVisible,
            confirmDeleteGeoRecord,
            confirmDecline,
            isGeomPolygon,
            tabs,
            activeIndex,
            selectTab,
            selectedComponent,
            geoRecord,
            handleGeoRecordPropertyUpdate,
            isNonGeometry,
            role,
            updateGeoRecordData,
            setIsPrivate,
            filterTabs,
            visibleTabs,
            scrollLeft,
            scrollRight,
            isFirstTabSelected,
            isLastTabSelected,
        };
    },
});
